<template>
  <div>
    <div class="header">
      <div class="container">
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li><router-link to="/">Inicio</router-link></li>
            <li class="is-active">
              <a href="#" aria-current="page">Editar</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="container">
      <venture-form
        title="Editar"
        :venture-id="$route.params.id"
      ></venture-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.header {
  background: linear-gradient(90deg, #fb5f3d 0%, #ffa63d 71.55%);
  color: white;
  height: 208px;
  padding: 30px;
  a {
    color: white;
  }
  .breadcrumb {
    li {
      a {
        color: white;
      }
      + li {
        &::before {
          color: white;
        }
      }
      &.is-active {
        a {
          color: white;
        }
      }
    }
  }
}
</style>
<script>
import VentureForm from "@/components/VentureForm";
export default {
  components: {
    VentureForm
  },
  metaInfo: {
    title: "Editar emprendimiento"
  }
};
</script>
